export default __webpack_public_path__ + "static/media/product-desktop.13fb7cae.jpg";